import { atom } from 'jotai'

export const nutritionistAtom = atom([])